/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IEtapas from 'Infotrack@Modelos/smartStock/etapas/entidades/etapas';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { AnyAction } from 'redux';

export interface IEstadoEtapas {
    estadoFormulario: boolean;
    entidadEtapas: IEtapas | null;
    recargarTabla: boolean;
    tipoFormulario: TipoFormulario;
}

export const estadoIncial: IEstadoEtapas = {
    entidadEtapas: null,
    estadoFormulario: false,
    recargarTabla: false,
    tipoFormulario: TipoFormulario.Creacion,
};

export enum acciones {
    CAMBIAR_ESTADO_FORMULARIO = 'CAMBIAR_ESTADO_FORMULARIO',
    RECARGAR_TABLA = 'RECARGAR_TABLA',
}

export const reductor = (estado: IEstadoEtapas, { type, payload }: AnyAction) => {
    switch (type) {
        case 'CAMBIAR_ESTADO_FORMULARIO': {
            return {
                ...estado,
                entidadEtapas: payload ? payload.entidadEtapas : null,
                estadoFormulario: !estado.estadoFormulario,
                tipoFormulario: payload ? payload.tipoFormulario : estado.tipoFormulario,
            };
        }
        case 'RECARGAR_TABLA':
            return {
                ...estado,
                recargarTabla: !estado.recargarTabla,
            };

        default:
            return estado;
    }
};
